import { combineReducers } from "@reduxjs/toolkit";
import { appInitialState, appReducer } from "./appReducer";

const rootReducer = combineReducers({
    app: appReducer
})


export const preloadedRootState = {
    app: appInitialState
}

export type TRootState = ReturnType<typeof rootReducer>
export default rootReducer